import React, { type FC, type ReactNode } from "react";
import clsx from "clsx";

type GroupItemProps = {
    label: ReactNode;
    value: ReactNode;
    noBorderB?: boolean;
};

export const GroupItem: FC<GroupItemProps> = (props) => {
    return (
        <div
            className={clsx(
                "text-body2 font-Regular flex items-center py-[11px] justify-between",
                { "border-t-[0.5px] border-border_2": !props.noBorderB }
            )}
        >
            <div className="text-text_2 mr-[10px]">{props.label}</div>
            <div className="text-text_1 break-all">{props.value}</div>
        </div>
    );
};
